import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=314cb45e"
import script from "./CatalogSearch.vue?vue&type=script&lang=js"
export * from "./CatalogSearch.vue?vue&type=script&lang=js"
import style0 from "./CatalogSearch.vue?vue&type=style&index=0&id=314cb45e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports